const STORAGE_KEY = 'petri:labware-settings';

export interface LabwarePlateSettings {
  model: string;
  heightMm: number;
  layout: {rows: number; columns: number};
  zOffsetMm: number;
}

export interface LabwareSettings {
  pcrPlate: LabwarePlateSettings;
  deepWellPlate: LabwarePlateSettings;
  lid: LabwarePlateSettings;
}

function createDefaultSettings(): LabwareSettings {
  return {
    pcrPlate: {
      model: 'biorad_96_wellplate_200ul_pcr',
      heightMm: 16.06,
      layout: {rows: 8, columns: 12},
      zOffsetMm: 0,
    },
    deepWellPlate: {
      model: 'nest_96_wellplate_2ml_deep',
      heightMm: 41.25,
      layout: {rows: 8, columns: 12},
      zOffsetMm: 0,
    },
    lid: {
      model: '', // Empty by default - no lid
      heightMm: 0,
      layout: {rows: 0, columns: 0},
      zOffsetMm: 0,
    },
  };
}

let _settings: LabwareSettings | undefined;

export function getLabwareSettings(): LabwareSettings {
  if (!_settings) {
    if (!process.env.CORGI_FOR_BROWSER) {
      _settings = createDefaultSettings();
    } else {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw) {
          const parsed = JSON.parse(raw) as Partial<LabwareSettings>;
          // Merge with defaults to handle missing fields
          const defaults = createDefaultSettings();
          _settings = {
            pcrPlate: {...defaults.pcrPlate, ...parsed.pcrPlate},
            deepWellPlate: {
              ...defaults.deepWellPlate,
              ...parsed.deepWellPlate,
            },
            lid: {...defaults.lid, ...parsed.lid},
          };
        } else {
          _settings = createDefaultSettings();
        }
      } catch (e) {
        console.error('Failed to load labware settings', e);
        _settings = createDefaultSettings();
      }
    }
  }
  return _settings;
}

export function setLabwareSettings(settings: LabwareSettings): void {
  _settings = settings;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch (e) {
    console.error('Failed to save labware settings', e);
  }
}
